import { Col, Input, Row, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
  QuestionCircleFilled,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const { Option } = Select;
function FileExtraction(props) {
  const [fileName, setFileName] = useState("");
  const [matchDisabled, setMatchDisabled] = useState(false);
  const [matchType, setMatchType] = useState("");
  const [eventType] = useState("");
  const eventMonitorObjects = {
    eventType: "",
    fileName,
    matchType,
    dbConnection: "",
    sql: "",
    environmentName: "",
  };
  useEffect(() => {
    props.saveFileExtractData(eventMonitorObjects);
  }, [eventType, fileName, matchType]);

  return (
    <div>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                setFileName("");
                setMatchDisabled(true);
              } else {
                setMatchDisabled(false);
              }
              setMatchType(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={fileName}
            disabled={matchDisabled}
            placeholder="file name"
            onChange={(e) => setFileName(e.target.value)}
            width="100%"
          />
        </Col>
      </Row>
    </div>
  );
}

export default FileExtraction;
